import { getCookie } from "components/common/cookie";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

// import { getToken } from "components/common/cookie";
import BackNavigation from "./common/BackNavigation";
import { useNavigate, useParams } from "react-router-dom";
import { UserCreators } from "redux/modules/user";

import PrivacyPolicy from "components/pages/home/PrivacyPolicy";

const AgreementContents = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const type = useParams().type;

  React.useEffect(() => {}, []);

  return (
    <div>
      {type === "tos" && <></>}
      {type === "pp1" && <PrivacyPolicy />}
      {type === "pp2" && (
        <Fragment>
          <BackNavigation />
          <PolicyWrap>
            <h2>개인정보 수집 및 이용(선택)</h2>
            <table>
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "40%" }} />
                <col style={{ width: "30%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>구분</th>
                  <th style={{ textAlign: "center" }}>수집∙이용 목적</th>
                  <th style={{ textAlign: "center" }}>수집 항목</th>
                  <th style={{ textAlign: "center" }}>보유∙이용기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "center" }}>선택</td>
                  <td style={{ textAlign: "center" }}>
                    이용자의 상품 및 서비스 이용 실적 정보를 활용한 통계 분석 및
                    상품 서비스 개선 제공, 맞춤형 서비스 제공을 위한 이용자 식별
                  </td>
                  <td style={{ textAlign: "center" }}>
                    [맞춤 서비스 제공]
                    <br />
                    성별, 닉네임, 연령대, 개업연월일, 사업장소재지
                  </td>
                  <td className="bold-weight">
                    <b>
                      <u>
                        - 회원 탈퇴 시 또는 계약 만료 시까지
                        <br />- 관계 법령에 따라 보존할 필요가 있는 경우 해당
                        법령에서 요구하는 기한까지 보유
                      </u>
                    </b>
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            ​
            <ul className="paragraph-info paragraph-info__left">
              <li>
                위 동의 내용을 거부하실 수 있으며, 동의를 거부하시더라도
                서비스는 이용하실 수 있습니다.
              </li>
              <li>
                개인정보 처리와 관련된 상세 내용은 ‘개인정보처리방침＇을 참고
              </li>
            </ul>
          </PolicyWrap>
        </Fragment>
      )}
      {type === "marketing" && (
        <Fragment>
          <BackNavigation />
          <PolicyWrap>
            <h1>마케팅 알림수신 동의(선택)</h1>
            <div className="table-wrap">
              <table className="table-default">
                <colgroup>
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "40%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "30%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>구분</th>
                    <th style={{ textAlign: "center" }}>수집∙이용 목적</th>
                    <th style={{ textAlign: "center" }}>수집 항목</th>
                    <th style={{ textAlign: "center" }}>보유∙이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>선택</td>
                    <td style={{ textAlign: "center" }}>
                      <b>
                        회원 전용 할인쿠폰 및 이벤트 등의 특별한 혜택 정보 안내
                      </b>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      마케팅 수신 동의(이메일)
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <b>수신동의 철회 및 회원 탈퇴 시</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ul className="paragraph-info paragraph-info__left">
              <li>
                위 동의 내용을 거부하실 수 있으며, 동의를 거부하시더라도
                서비스는 이용하실 수 있습니다.
              </li>
              <li>
                개인정보 처리와 관련된 상세 내용은 ‘개인정보처리방침＇을 참고
              </li>
            </ul>
          </PolicyWrap>
        </Fragment>
      )}
    </div>
  );
};

export default AgreementContents;

const PolicyWrap = styled.div`
  margin: 0px 16px;
  font-size: 10px;

  h1 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;
